import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        addCampaign: builder.mutation({
            query: (body) => ({
                url: `campaign/addCampaign`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getCampaignById: builder.mutation({
            query: (body) => ({
                url: `campaign/getCampaignById`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        updateCampaign: builder.mutation({
            query: (body) => ({
                url: `campaign/updateCampaign`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getReportingUsers: builder.query({
            query: () => ({
                url: `campaign/getReportingUsers`,
                method: "GET",
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),

        getReportingManagers: builder.query({
            query: () => ({
                url: `campaign/getReportingManagers`,
                method: "GET",
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),

        getReportingSupervisors: builder.query({
            query: (body) => ({
                url: `campaign/getReportingSupervisors`,
                method: "POST",
                body
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),


        getCampaignList: builder.mutation({
            query: (body) => ({
                url: `campaign/getAllCampaigns`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getCampaignSummary: builder.query({
            query: () => ({
                url: `campaign/getCampaignSummary`,
                method: "GET",
            }),
            providesTags: ["CampaignSummary"],
        }),

        updateCampaignStatus: builder.mutation({
            query: (body) => ({
                url: `campaign/updateStatus`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getCampaign: builder.mutation({
            query: (body) => ({
                url: `campaign/getCampaign`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getCampaignAgents: builder.mutation({
            query: (body) => ({
                url: `campaign/getAgents`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getSupervisorsByCampaign: builder.mutation({
            query: (payload) => ({
                url: "/campaign/getSupervisorByCampaign",
                method: "POST",
                body: payload,
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getAgentsByQueue: builder.mutation({
            query: (body) => ({
                url: `campaign/getAgentsByQueue`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        addAgent: builder.mutation({
            query: (body) => ({
                url: `campaign/addAgent`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        removeAgent: builder.mutation({
            query: (body) => ({
                url: `campaign/removeAgents`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getCampaignAssignmentFlow: builder.query({
            query: (campaignId) => ({
                url: "campaign/getCampaignAssignmentFlow",
                method: "POST",
                body: {
                    campaignId,
                },
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),
    })

})

export const { useAddCampaignMutation, useGetCampaignByIdMutation, useUpdateCampaignMutation, useGetReportingUsersQuery, useGetReportingManagersQuery, useLazyGetReportingSupervisorsQuery, useGetCampaignListMutation, useGetCampaignSummaryQuery, useUpdateCampaignStatusMutation, useGetCampaignMutation, useGetCampaignAgentsMutation, useGetSupervisorsByCampaignMutation, useGetAgentsByQueueMutation, useAddAgentMutation, useRemoveAgentMutation, useGetCampaignAssignmentFlowQuery } = Api